import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductTypeValueService, BrandService } from '@app/api/api';
import { environment } from 'environments/environment';
import { UtilService } from '@app/services/util.service';
@Component({
  selector: 'meu-search-by-brand',
  templateUrl: './search-by-brand.component.html',
  styleUrls: ['./search-by-brand.component.scss'],
})
export class SearchByBrandComponent implements OnInit {
  totalProduct: any;
  pagesize: any = 10;
  pageIndex: any = 1;
  lstProductSearch = [];
  brandName = '';
  brandId = null;
  host = environment.backendhost;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private productTypeValueService: ProductTypeValueService,
    private brandService: BrandService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.brandId = params.brandId;
      if (this.brandId) {
        this.brandService.apiBrandsIdGet(this.brandId).subscribe((r) => {
          if (r.success) {
            this.brandName = r.data.name;
          }
        });
      }
      this.getListProduct();
    });
  }

  getListProduct() {
    this.productTypeValueService
      .apiFullProductsGet('is_hidden==false', '', this.pageIndex, this.pagesize, '', this.brandId)
      .subscribe((res) => {
        if (res.success) {
          this.lstProductSearch = res.data.collection;
          this.pagesize = res.data.pagesize;
          this.pageIndex = res.data.pageIndex;
          this.totalProduct = res.data.total;

          for (let i = 0; i < this.lstProductSearch.length; i++) {
            this.lstProductSearch[i].seo_name = UtilService.slugify(
              this.lstProductSearch[i].product.name
            );

            this.lstProductSearch[i].default_image =
              this.host + this.lstProductSearch[i].product.default_image;
            this.lstProductSearch[i].percentdiscount = this.calculatePercentPrice(
              this.lstProductSearch[i].product.price,
              this.lstProductSearch[i].product.origin_price
            );

            this.lstProductSearch[i].available_quantity =
              this.lstProductSearch[i].type_values.length === 0
                ? this.lstProductSearch[i].product.quantity
                : this.calculateAvailableQuantity(this.lstProductSearch[i].type_values);
          }
        }
        this.changeDetectorRef.detectChanges();
      });
  }

  calculateAvailableQuantity(arrType = []) {
    let total = 0;
    for (let i = 0; i < arrType.length; i++) {
      total += arrType[i].quantity;
    }
    return total;
  }

  calculatePercentPrice(price, originPrice) {
    if (originPrice == 0) return 0;
    let percent = 0;
    percent = Math.round(100 - (price / originPrice) * 100);
    return percent;
  }

  paginatorChange(event) {
    this.pagesize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.getListProduct();
  }

  selectProduct(productId, seoName) {
    this.router.navigate(['/product/' + productId + '/' + seoName + '/details']);
  }
}
